import React from 'react'

import QrReader from 'react-qr-reader'
import Portal from './Portal'
import Modal from './Modal'

const QRModal = ({ setScanResultWebCam, active, setActive }) => {
  const handleErrorWebCam = error => {
    console.log(error)
  }
  const handleScanWebCam = result => {
    if (result) {
      setScanResultWebCam(result)
      setActive(false)
    }
  }
  return (
    <Portal>
      <Modal active={active} setActive={setActive} autoWidth>
        <div className='qr-modal'>
          <QrReader
            delay={300}
            style={{ width: '100%' }}
            onError={handleErrorWebCam}
            onScan={handleScanWebCam}
          />
        </div>
      </Modal>
    </Portal>
  )
}

export default QRModal
